import { render, staticRenderFns } from "./UserActionInfoUnbanPlayer.vue?vue&type=template&id=07ba7e5c&"
import script from "./UserActionInfoUnbanPlayer.vue?vue&type=script&lang=js&"
export * from "./UserActionInfoUnbanPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports